import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import Plus from '@/components/UI/svg/SaveElectric/Plus';
import Minus from '@/components/UI/svg/SaveElectric/Minus';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';

export default function G() {
    const { useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('save_electric');
    const [activeFAQ, setActiveFAQ] = useState(0);
    const router = useRouter();

    const gotoPage = (data: any) => {
        const { link, name } = data;
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: name,
            position: 'Electricity Saving',
        });
        router.push(link);
    };

    const productList = [
        {
            name: t('sec_10_product1'),
            img: ['DP_400W.webp', 'DP_400W.png'],
            link: 'https://jp.ecoflow.com/products/delta-pro-solar-generator-400w-solar-panel',
        },
        {
            name: t('sec_10_product2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1730191302157/jp-soeb-img-1.png',
            link: 'https://jp.ecoflow.com/products/delta-2-max-extra-battery-220w-solar-panel-bundle',
        },
        {
            name: t('sec_10_product3'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1730191302356/jp-soeb-img-2.png',
            link: 'https://jp.ecoflow.com/products/delta-3-plus-portable-power-station-220w-solar-panel',
        },
        {
            name: t('sec_10_product4'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1730191302535/jp-soeb-img-3.png',
            link: 'https://jp.ecoflow.com/products/river-2-pro-solar-generator-220w-solar-panel',
        },
        {
            name: t('sec_10_product5'),
            img: ['D2M_W2.webp', 'D2M_W2.png'],
            link: 'https://jp.ecoflow.com/products/delta-2-max-wave-2-portable-air-conditioner-bundle',
        },
    ];

    const faqList = [
        {
            title: t('sec_11_faq1'),
            desc: t('sec_11_ans1'),
        },
        {
            title: t('sec_11_faq2'),
            desc: t('sec_11_ans2'),
        },
        {
            title: t('sec_11_faq3'),
            desc: t('sec_11_ans3'),
        },
    ];

    return (
        <div className={`save-electric-g ${css.SaveElectricG}`}>
            <section className="section-a text-wrapper">
                <h2 className="title">{t('sec_10_title')}</h2>
                <Swiper className="product-wrapper" initialSlide={0} lazy={true} spaceBetween={20} width={310}>
                    {productList.map((item, index) => (
                        <SwiperSlide key={index} className="product">
                            <NextImage
                                webpSrc={typeof item.img === 'string' ? item.img : require(`@publicLocal/save-electric/h5/${item.img[0]}`)}
                                src={typeof item.img === 'string' ? item.img : require(`@publicLocal/save-electric/h5/${item.img[1]}`)}
                                alt={item.name}
                                aria-label={item.name}
                            />
                            <p className="name">{item.name}</p>
                            <p className="learn-more" onClick={() => gotoPage(item)}>
                                {t('btn')}
                            </p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>
            <EmailSubscribe locale="jp" className="email-subscribe" pageType={PAGE_TYPE.Save} />
            <section className="section-b text-wrapper">
                <h3 className="title">{t('sec_11_title')}</h3>
                <div className="faq-wrapper">
                    {faqList.map((item, index) => (
                        <div
                            className={`faq ${activeFAQ === index + 1 ? 'active' : ''}`}
                            key={index}
                            onClick={() => setActiveFAQ(activeFAQ === index + 1 ? 0 : index + 1)}
                        >
                            <div className="icon">
                                {activeFAQ === index + 1 ? <Minus width="0.27rem" height="0.27rem" /> : <Plus width="0.27rem" height="0.27rem" stroke="#000" />}
                            </div>
                            <p className="faq-title">{item.title}</p>
                            <p className="desc">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
